import { useState } from 'react'

import { PluginApi } from '@remixproject/plugin-utils'
import { PluginClient } from '@remixproject/plugin'
import { IRemixApi } from '@remixproject/plugin-api'

import Accordion from 'react-bootstrap/Accordion'

import DeployedContracts from './DeployedContracts'
import TransactionValueForm from '../shared/TransactionValueForm'
import GasLimitForm from '../shared/TransactionGasLimitForm'
import { toBigInt } from 'ethers'

type InteractProps = {
    client: PluginClient<any, Readonly<IRemixApi>> & PluginApi<Readonly<IRemixApi>>
}

const Interact = ({ client }: InteractProps) => {
    const [gasLimit, setGasLimit] = useState('0')
    const [value, setValue] = useState(toBigInt(0))
    
    return (
        <Accordion.Item eventKey='4'>
            <Accordion.Header><b>4 - Interact</b></Accordion.Header>
            <Accordion.Body className='interact-container'>
                <GasLimitForm group='interact' updateGasLimit={setGasLimit} />
                <TransactionValueForm updateValue={setValue} />
                <DeployedContracts client={client} gasLimit={gasLimit} value={value} />
            </Accordion.Body>
        </Accordion.Item>
    )
}

export default Interact